import { Tag } from '@factorialco/deprecated-design-system'
import { CandidateSourceTagFragment } from 'generated/resources/graphql'
import { useToggle } from 'usehooks-ts'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { getSourceLabel } from 'modules/ats/lib/utils/candidateSources'

import { EditSourceModal } from './EditSourceModal'

interface Props {
  application: CandidateSourceTagFragment
}

export const CandidateSourceTag = ({ application }: Props) => {
  const [showEditSourceModal, toggleEditSourceModal] = useToggle(false)

  if (!application.applicationSource) return null

  const sourceTagType =
    application.applicationSource.category === 'referral' ? 'radical' : 'viridian'

  return (
    <>
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Tag rightItem="dropdown" type={sourceTagType} inline showActionIcon>
            {getSourceLabel(application.applicationSource.name)}
          </Tag>
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="start">
          <PopoverMenu.TouchableOption
            onClick={toggleEditSourceModal}
            title={i18n.t('ats.candidates.application_view.edit_source.popover_title')}
            description={i18n.t('ats.candidates.application_view.edit_source.popover_description')}
          />
        </PopoverMenu.Content>
      </PopoverMenu>

      {showEditSourceModal && (
        <EditSourceModal application={application} onClose={toggleEditSourceModal} />
      )}
    </>
  )
}
